export default "__VITE_ASSET__CT9JZN5f__"